<template>
  <el-table
    :data="newList"
    height="300px">
    <el-table-column
      prop="idx"
      width="50">
    </el-table-column>
    <el-table-column
      prop="productName"
      label="商品名称">
    </el-table-column>
    <el-table-column
      width="95"
      prop="periodInStockQuantity"
      :formatter="row=> row.periodInStockQuantity + '件'"
      label="本期入库数量">
    </el-table-column>
    <el-table-column
      width="95"
      prop="periodOutStockQuantity"
      :formatter="row=> row.periodOutStockQuantity + '件'"
      label="本期出库数量">
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'InOutStockTable',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    newList() {
      return this.list.map((i, idx) => {
        return {
          ...i,
          idx: idx + 21
        }
      })
    }
  }
}
</script>

